module.exports = __webpack_public_path__ + "img/gxlogo4.0ae5d1cc.png";